/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'well-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {

  @Input() title = '';

  @Input() subtitle = '';

  @Input() styleClass: any;

  constructor() {
  }

  ngOnInit() {
  }

}
